import React, { FunctionComponent } from 'react';
import { Button, Modal, Pill } from 'rs-emd-ui-atoms';
import { FilterArea } from '../..';
import { getLabel } from '../../../../helpers/html.utils';
import { ILabel } from '../../../../models/common/label.model';
import { IPLPFacets } from '../../../../models/plp/plp-facets.model';
import { IPLPSummary } from '../../../../models/plp/plp-summary.model';
import { OrderedFilter } from '../filters';
import styles from './filter-modal-component.module.scss';

type FilterModalProps = {
  labels?: ILabel[] | null;
  filterArea: IPLPFacets;
  previewFilterArea: IPLPFacets;
  summary?: IPLPSummary | null;
  selectedFilters: OrderedFilter[];
  closeCallback: () => void;
  onSelectNewFilters: (selectedFilters: OrderedFilter[]) => void;
  onFilterProducts: (selectedFilters: OrderedFilter[]) => void;
};

export const FilterModal: FunctionComponent<FilterModalProps> = (props: FilterModalProps) => {
  let footer = (
    <div className={styles.overview}>
      {props.selectedFilters.length > 0 && (
        <>
          <div className={styles.title}>
            <span>{getLabel(props.labels, 'filters_applied')}</span>
            <button className='link' onClick={() => props.onSelectNewFilters([])}>
              {getLabel(props.labels, 'filters_clear_all')}
            </button>
          </div>
          <div className={styles.selections}>
            {props.selectedFilters.map((category, i) => {
              return (
                <div>
                  <Pill
                    isClosable={true}
                    isOnClickClosable={true}
                    class={`${styles.pill} ${i === props.selectedFilters.length - 1 ? styles.last : ''}`}
                    closeCallback={() => removeSelectedFilter(category)}
                    key={`${category.id}_${category.filter.id}`}
                    icon={category.filter.id === 'flag_better_world' ? 'sustainable' : undefined}
                    label={`${category.name ? category.name + ':' : ''} ${category.filter.displayValue}`}
                  />
                </div>
              );
            })}
          </div>
        </>
      )}
      <div className={styles.cta}>
        <Button
          buttonType='primary'
          className={styles.view}
          text={getLabel(props.labels, 'filters_apply_cta').replace('[total]', props.summary?.totalProducts.toString() ?? '')}
          onClick={() => onFilterProducts()}></Button>
        <Button buttonType='text' text={getLabel(props.labels, 'cancel')} onClick={props.closeCallback}></Button>
      </div>
    </div>
  );

  return (
    <Modal
      headerElt={<div className={styles.header}>{getLabel(props.labels, 'filters_cta')}</div>}
      isMobileFullScreen={true}
      isSidebar={true}
      footerElt={
        (props.selectedFilters.length > 0 ||
          (props.filterArea.appliedFilters?.length ?? 0) > 0 ||
          (props.filterArea.appliedFlagFilters?.length ?? 0) > 0) &&
        footer
      }
      closeCallback={props.closeCallback}>
      <FilterArea
        labels={props.labels}
        filterArea={props.previewFilterArea}
        selectedFilters={props.selectedFilters}
        onChangeSelection={(selectedFilters) => props.onSelectNewFilters(selectedFilters)}></FilterArea>
    </Modal>
  );

  function removeSelectedFilter(filter: OrderedFilter) {
    let currfilters = props.selectedFilters.filter((f) => f !== filter);

    props.onSelectNewFilters(currfilters);
  }

  function onFilterProducts() {
    props.onFilterProducts(props.selectedFilters);
  }
};
